import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "ContentHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.722 15.992a4.11 4.11 0 0 1-1.867 3.456L11.67 29.32A4.1 4.1 0 0 1 9.421 30a4.1 4.1 0 0 1-1.96-.5 4.07 4.07 0 0 1-2.15-3.626v-5.54a3.185 3.185 0 0 1-2.033-2.976c0-1.764 1.43-3.193 3.192-3.193s3.199 1.429 3.199 3.193a3.185 3.185 0 0 1-2.037 2.976v5.54c0 .676.35 1.264.932 1.583a1.77 1.77 0 0 0 1.837-.082l15.185-9.878c.521-.335.814-.887.814-1.505s-.293-1.177-.814-1.518l-15.165-9.85a1.76 1.76 0 0 0-1.83-.077 1.77 1.77 0 0 0-.94 1.577v2.977c0 .64-.52 1.16-1.16 1.16s-1.16-.52-1.16-1.16V6.125c0-1.512.825-2.899 2.156-3.62a4.05 4.05 0 0 1 4.203.174l15.165 9.852a4.11 4.11 0 0 1 1.867 3.46"
    })
  }));
};
ContentHubIcon.displayName = 'ContentHubIcon';